/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.exceptionDetailDialog = new ExceptionDetailDialog();
        }
*/
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { GenericEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/GenericEvaluator";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ExceptionDetailDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ExceptionDetailDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemViewErrorPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemViewErrorProperties = {
    [name in keyof EntityCommandProcessInstanceItemViewErrorPropertyValues]: Property<EntityCommandProcessInstanceItemViewErrorPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemViewError extends IEntityCommand, EntityCommandProcessInstanceItemViewErrorProperties
{
}

export class EntityCommandProcessInstanceItemViewError extends EntityCommand implements IEntityCommandProcessInstanceItemViewError
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemViewError";
    public static override className = "EntityCommandProcessInstanceItemViewError";

    // #region Global Variables

    private static exceptionDetailDialog: ExceptionDetailDialog

    // #endregion

    // #region Constructor

    static {
        this.exceptionDetailDialog = new ExceptionDetailDialog();
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemViewErrorPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "View Error",
                entityName: "ProcessInstanceItem",
                key: "VIEWERROR",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new GenericEvaluator({
                    evaluateFn: (_, state) =>
                    {
                        if (!(state instanceof EntityCommandInformation))
                            return false;

                        const
                            status = state.record.get()?.statusLookupItem?.description;

                        switch (status)
                        {
                            case "Initialization Failed":
                            case "Execution Failed":
                            case "Errored":
                            case "Completion Failed":
                                return true;
                        }

                        return false;
                    }
                }),
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "statusLookupItem.description",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemViewErrorPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "GetProcessInstanceItemExceptionDetail", data: ObjectHelper.toJson({ processInstanceItemId: recordId }) })
                            .executeAsync()
                            .then(data =>
                            {
                                if (!data)
                                    return;

                                return (
                                    EntityCommandProcessInstanceItemViewError.exceptionDetailDialog
                                        .openAsync(data)
                                );
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

